import { SDKOptions, SportTypes } from '../../types';
import { generateRequest } from '../http.service';

export interface IStandingsCompetitionDetailsProps {
  competition_id?: string;
  sport?: SportTypes;
}

export const getStandingsCompetitionDetails = async ({
  params,
  sdkOptions,
  sport,
}: {
  params: IStandingsCompetitionDetailsProps;
  sdkOptions: SDKOptions;
  sport: SportTypes;
}) => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/${sport}/v2/seasons/available?translation_language=${sdkOptions.dataConfigLang}`;

  const baseParams = {
    ...params,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
